export default __webpack_public_path__ + "static/media/Beastmaster's Heretical Eye.4818eed6.jpg";